import { render, staticRenderFns } from "./ProjectCreateTemplate.vue?vue&type=template&id=165c833e&"
import script from "./ProjectCreateTemplate.vue?vue&type=script&lang=js&"
export * from "./ProjectCreateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('165c833e')) {
      api.createRecord('165c833e', component.options)
    } else {
      api.reload('165c833e', component.options)
    }
    module.hot.accept("./ProjectCreateTemplate.vue?vue&type=template&id=165c833e&", function () {
      api.rerender('165c833e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/creationPages/ProjectCreateTemplate.vue"
export default component.exports